import { render, staticRenderFns } from "./LeaveEmployeeTableControl.vue?vue&type=template&id=68b86142&scoped=true&"
import script from "./LeaveEmployeeTableControl.vue?vue&type=script&lang=js&"
export * from "./LeaveEmployeeTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b86142",
  null
  
)

export default component.exports